<div class="device-container vertical-container">
    <div class="sensors-container horizontal-container">
        <div class="camera"></div>
        <span style="width: 4px;"></span>
        <div class="speaker"></div>
    </div>
    <span style="height: 4px;"></span>
    <img class="screenshot" [src]="src" />
    <span style="height: 8px;"></span>
</div>